/**
 * Product feeds (ADR-096): the file Google Merchant Center, Meta Commerce
 * Manager, TikTok and Snapchat catalogues read every day. All four read
 * Google's format, so a channel is an address the store switches on — not a
 * format of its own.
 */
export const FEED_CHANNELS = ['google', 'meta', 'tiktok', 'snapchat'];
export const FEED_CONDITIONS = ['new', 'refurbished', 'used'];
export const FEEDS_DEFAULTS = {
    channels: { google: false, meta: false, tiktok: false, snapchat: false },
    includeOutOfStock: true,
    condition: 'new',
    brandFallback: true,
};
/** The most rows one feed carries; a store larger than this needs a pushed catalogue. */
export const FEED_MAX_ROWS = 50_000;
/** What the platforms keep of a title and a description; longer is cut, not refused. */
export const FEED_TITLE_MAX = 150;
export const FEED_DESCRIPTION_MAX = 5000;
/** Pictures per row: the main one and ten more. */
export const FEED_IMAGES_MAX = 11;
/** Option codes the platforms have a field for (ADR-096). */
export const FEED_OPTION_FIELDS = ['color', 'size', 'material', 'pattern'];
/** Why a product is not in the feed, or will not do well there. */
export const FEED_ISSUES = [
    'excluded',
    'no-image',
    'not-a-parcel',
    'out-of-stock',
    'no-identifier',
    'no-brand',
    'no-google-category',
    'no-description',
];
/** The issues that keep a product out; the rest are warnings on a product that is in. */
export const FEED_LEFT_OUT = ['excluded', 'no-image', 'not-a-parcel', 'out-of-stock'];
//# sourceMappingURL=feeds.js.map